<template>
    <el-form-item :label="labelName" prop="district_id" :label-width="itemLabelWidth">
        <div class="block">
            <el-cascader v-if="districts"
                size="small"
                v-model="selectedOptions"
                :options="districts"
                @change="activeChange"
                :props="props"
                clearable
                @clean="activeChange"
                style="width:100%"
                filterable
                :disabled="isDisabled"
            >
            </el-cascader>
        </div>
    </el-form-item>
</template>

<script>
    import CommonService from "~/services/common";

    export default {
        name: "DistrictLinkage",
        data() {
            return {
                //定义变量
                districts: [],
                props: {//elemetn UI中 Cascader 级联选择器的 attribute
                    value: 'id', //指定选项的值为选项对象的某个属性值
                    label: 'label', //指定选项标签为选项对象的某个属性值
                    // expandTrigger: 'hover',
                    checkStrictly: true
                },
                selectedOptions: [],
            };
        },

        props: {
            labelName: {
                type: String,
                default: '所在地区',
                required: false
            },
            provinceId: {
                type: Number,
                default: 0,
                required: false
            },

            cityId: {
                type: Number,
                default: 0,
                required: false
            },

            districtId: {
                type: Number,
                default: 0,
                required: false
            },

            // 是否一改变选中就触发联动
            triggerOnChange: {
                type: Boolean,
                default: false,
                required: false
            },

            itemLabelWidth: {
                type: String,
                default: '',
                required: false,
            },

            isDisabled: {
                type: Boolean,
                default: false,
                required: false
            },
        },

        //vue.js 钩子函数，在实例创建完成后立即调用
        created() {
            this.selectedOptions = [];
            CommonService.getAreaTree().
                then(res => {
                    if (res.code == 0 && res.data) {
                        this.districts = res.data;
                        this.setSelectedOptions();
                        // //如果省市区需要默认选中，否则值没有更改
                        if (typeof (this.selectedOptions) != '') {
                            this.activeChange(this.selectedOptions);
                        }
                    }
                })
            // console.log('进入：', this.provinceId, this.cityId, this.districtId);
        },

        methods: {

            //设置SelectedOptions数组，用于级联选择器默认选中
            setSelectedOptions() {
                if (!this.provinceId) return;
                this.selectedOptions.push(String(this.provinceId || ''));
                if (!this.cityId) return;
                this.selectedOptions.push(String(this.cityId || ''));
                if (!this.districtId) return;
                this.selectedOptions.push(String(this.districtId || ''));
            },


            // handleChange(value) {
            //     if (this.triggerOnChange == true) {
            //         this.activeChange(value);
            //         return;
            //     }

            //     value = Object.assign([],value);
            //     if (!value[0]) value[0] = 0;
            //     if (!value[1]) value[1] = 0;
            //     if (!value[2]) value[2] = 0;
            //     this.$emit("change", value);
            // },

            activeChange(value) {
                this.selectedOptions = value;
                value = Object.assign([],value);
                if (!value[0]) value[0] = 0;
                if (!value[1]) value[1] = 0;
                if (!value[2]) value[2] = 0;
                // console.log('进入activeChange：', value);
                this.$emit("change", value);
            },

            //地区选择value重置
            reset() {
                this.selectedOptions = [];
            },

        }
    }

</script>


// WEBPACK FOOTER //
// src/widgets/DistrictLinkage.vue